module.exports = __webpack_public_path__ + "static/img/prot_grey.4ae199f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prot_grey.png
// module id = m5BV
// module chunks = 21